import { styled } from 'styled-components';

import { DropdownListMenuItem } from '#/components/Dropdown/menus/ListMenu/DropdownListMenuItem';
import { Hyperlink } from '#/components/Hyperlink/Hyperlink';
import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const WorkspaceMobileDropdownHolder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  overflow-y: scroll;
  background: white;
  box-shadow: -2px 0 4px rgb(0 0 0 / 0.1);

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const WorkspaceMobileDropdownHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
  padding: 0 ${gutterWidth / 2}px;
  border-bottom: 1px solid ${colors.selectionGrey};
`;

export const WorkspaceDropdownButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .workspace-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100px;
  }

  @media all and (max-width: ${cssBreakpoints.xsDown}) {
    .workspace-text {
      display: none;
    }
  }
`;

export const WorkspaceMobileDropdownBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WorkspaceMobileDropdownSection = styled.section({});

export const WorkspaceMobileDropdownSectionTitle = styled.h5`
  text-transform: uppercase;
  width: 100%;
  margin: 0;
  height: 64px;
  color: ${colors.mediumContentGrey};
  background: ${colors.backgroundBlue};
  font-size: 16px;
  font-weight: normal;
  padding-left: 20px;
  display: flex;
  align-items: center;
`;

export const WorkspaceMobileDropdownLink = styled(Hyperlink)<{
  $selected: boolean;
}>`
  display: flex;
  height: 64px;
  gap: 8px;
  padding-left: 20px;
  align-items: center;
  font-size: 16px;
  font-weight: normal;
  color: ${colors.mediumContentGrey};
  text-decoration: none;
  background-color: ${(props) =>
    props.$selected ? colors.selectionBlue : 'transparent'};
`;

export const WorkspaceDropdownListMenuItem = styled(DropdownListMenuItem)<{
  $selected: boolean;
}>`
  gap: 8px;
  background-color: ${(props) =>
    props.$selected ? colors.selectionBlue : 'transparent'};
`;
